module.exports = __webpack_public_path__ + "static/media/csrddc_img3.11404bd1.svg";